import { create } from 'zustand';

export interface MediaStore {
  isMuted: boolean;
  isSpeakerOn: boolean;
  setIsMuted: (isMuted: boolean) => void;
  setIsSpeakerOn: (isSpeakerOn: boolean) => void;
  toggleIsMuted: () => void;
  toggleIsSpeakerOn: () => void;
}

export const useMediaStore = create<MediaStore>((set) => ({
  isMuted: true, // 초기값 true: 동의 전에는 마이크 꺼짐
  isSpeakerOn: true,
  setIsMuted: (isMuted) => set({ isMuted }),
  setIsSpeakerOn: (isSpeakerOn) => set({ isSpeakerOn }),
  toggleIsMuted: () => set((state) => ({ isMuted: !state.isMuted })),
  toggleIsSpeakerOn: () => set((state) => ({ isSpeakerOn: !state.isSpeakerOn })),
}));